import ServiceService from 'services/Service.service';
import { observable } from 'mobx';

class ServicesStore {
  services = observable([]);
  initialFetchDone = observable.box(false);

  async fetchServices() {
    if (this.isLoaded()) {
      return this.services;
    }

    try {
      const items = await ServiceService.fetchServices();
      if (items.isEmpty) {
        return [];
      }
      this.services.push(...items.items);
    } catch (e) {
      this.initialFetchDone.set(false);
      console.error('Failed to fetch services data', e);
      return null;
    }
    this.initialFetchDone.set(true);

    return this.services;
  }

  isLoaded() {
    return this.initialFetchDone.get();
  }
}

export default new ServicesStore();



// WEBPACK FOOTER //
// ./src/stores/Services.store.js